import wx from 'weixin-js-sdk'
import eventBus from '@/event_bus'
import { PLAYER_NAME } from '../data'

export const audioBrowser = {
    name: PLAYER_NAME.BROWSER,

    play (dom) {
        const promise = dom.play()

        // https://stackoverflow.com/a/41822526
        if (promise !== undefined) {
            promise.catch(() => {
                dom.play()
            })
        }
    },
    stop (dom) {
        dom.pause()
        dom.currentTime = 0
    },
    pause (dom) {
        dom.pause()
    }
}

export const audioWechat = {
    name: PLAYER_NAME.WECHAT,

    get isReady () {
        return eventBus.isWechatJSSDKReady
    },

    play (localId) {
        if (!this.isReady) {
            return
        }
        wx.playVoice({
            localId
        })
    },
    stop (localId) {
        if (!this.isReady) {
            return
        }
        wx.stopVoice({
            localId
        })
    },
    pause (localId) {
        if (!this.isReady) {
            return
        }
        wx.pauseVoice({
            localId
        })
    }
}
